import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GruposService {
  PATH_GRUPOS = '';

  constructor(private http: HttpClient) {
    this.PATH_GRUPOS = environment.API_BASE + '/Groups';
  }

  getInfoAdicionalGrupo(idGrupo: number): Observable<string> {
    return this.http.get<string>(this.PATH_GRUPOS + '/InfoAdicionalGrupo/' + idGrupo);
  }

}